import React from 'react';

const SharedSelect = ({ label, value, onChange, options, className = '' }) => {
  return (
    <div className="mb-4">
      {label && <label className="block text-black text-sm font-bold mb-2">{label}</label>}
      <select
        value={value}
        onChange={onChange}
        className={`w-full px-4 py-2 bg-gray-100 text-black border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#961914] transition-all duration-200 ${className}`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SharedSelect;